import axiosAdmin from "../../api/axiosAdmin";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const PlacesPage = () => {
  const [requests, setRequests] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPlaceName, setNewPlaceName] = useState("");

  const fetchRequests = async () => {
    try {
      const response = await axiosAdmin.get("/place");

      setRequests(response.data);
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const addPlace = async () => {
    if (!newPlaceName.trim()) {
      toast.error("Place name cannot be empty");
      return;
    }

    try {
      await axiosAdmin.post("/place/create", {
        placeName: newPlaceName,
      });

      toast.success("Place added successfully");
      setNewPlaceName("");
      setIsModalOpen(false);
      fetchRequests();
    } catch (error) {
      console.error("Error adding place:", error);
      toast.error("Failed to add place");
    }
  };

  const deletePlace = async (id) => {
    if (!window.confirm("Are you sure you want to delete this place?")) return;

    try {
      await axiosAdmin.delete(`/place/${id}/delete`);

      toast.success("Place deleted successfully");
      fetchRequests();
    } catch (error) {
      console.error("Error deleting place:", error);
      toast.error("Failed to delete place");
    }
  };

  return (
    <div>
      <div className="flex items-center mb-4">
        <h1 className="text-2xl font-bold">Places</h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-green-500 text-white rounded ml-4"
        >
          Add Place
        </button>
      </div>

      <table className="hidden md:table w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 border">Name</th>
            <th className="p-2 border w-1/4">Dj</th>
            <th className="p-2 border">Price (PLN)</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr key={request.id} className="hover:bg-gray-50">
              <td className="p-2 border">{request.name}</td>
              <td className="p-2 border">
                {request.dj ? request.dj.name : "N/A"}
              </td>
              <td className="p-2 border">
                {request.dj ? request.dj.currentPrice : "N/A"}
              </td>
              <td className="p-2 border text-center">
                <button
                  onClick={() => deletePlace(request.id)}
                  className="px-3 py-1 bg-red-500 text-white rounded"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="md:hidden space-y-4 py-4">
        {requests.map((request) => (
          <div
            key={request.id}
            className="w-full border rounded-lg p-4 shadow-md bg-white"
          >
            <div className="font-bold text-lg">{request.name}</div>
            <div className="text-sm text-gray-500">
              Dj: {request.dj ? request.dj.name : "N/A"}
            </div>
            <div className="text-sm text-gray-500">
              Price: {request.dj ? request.dj.currentPrice : "N/A"}
            </div>
            <button
              onClick={() => deletePlace(request.id)}
              className="mt-2 px-3 py-1 bg-red-500 text-white rounded"
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Add New Place</h2>
            <input
              type="text"
              value={newPlaceName}
              onChange={(e) => setNewPlaceName(e.target.value)}
              className="w-full p-2 border rounded mb-4"
              placeholder="Enter place name"
            />
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={addPlace}
                className="px-4 py-2 bg-green-500 text-white rounded"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default PlacesPage;
